import { render, staticRenderFns } from "./CatalogsForm.vue?vue&type=template&id=40af21c6&"
import script from "./CatalogsForm.vue?vue&type=script&lang=js&"
export * from "./CatalogsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports